// src/modules/comission/hooks/useComissionHandlers.ts

import { useToast } from "../../../shared/hooks";
import { ToastContent } from "../../../shared/components";
import { ComissionServices } from "../../../shared/services/api/comission/ComissionServices";

export const useComissionHandlers = (dataIni: string, dataFim: string, setIsLoading: (loading: boolean) => void) => {
	const toastHandler = useToast();

	const handleCancelComissions = async (obs: string, confirmdate: string, ids: string[]) => {
		if (!ids.length) return;

		setIsLoading(true);
		let successCount = 0;

		try {
			for (const id of ids) {
				const result = await ComissionServices.updateValuesComission(id, { reason: obs, status: "canceled", cancelDate: confirmdate }); // ids como array
				if (!(result instanceof Error)) {
					successCount++;
				}
			}

			if (successCount > 0) {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: (
						<ToastContent
							title="Sucesso"
							content={successCount === 1 ? "Comissão cancelada com sucesso." : `${successCount} comissões canceladas com sucesso.`}
						/>
					),
				});
			} else {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro" content="Não foi possível cancelar as comissões." />,
				});
			}
		} catch (error) {
			console.error("Erro inesperado:", error);
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="Falha ao processar os cancelamentos." />,
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handlePaymentComissions = async (obs: string, confirmdate: string, ids: string[]) => {
		if (!ids.length) return;

		setIsLoading(true);
		let successCount = 0;

		try {
			for (const id of ids) {
				const result = await ComissionServices.updateValuesComission(id, { reason: obs, status: "paid", clientPayment: confirmdate }); // ids como array
				if (!(result instanceof Error)) {
					successCount++;
				}
			}

			if (successCount > 0) {
				toastHandler.present({
					type: "success",
					position: "top-right",
					messageOrContent: (
						<ToastContent
							title="Sucesso"
							content={successCount === 1 ? "Cobrança baixada com sucesso." : `${successCount} cobranças baixadas com sucesso.`}
						/>
					),
				});
			} else {
				toastHandler.present({
					type: "error",
					position: "top-right",
					messageOrContent: <ToastContent title="Erro" content="Não foi possível realizar a baixa manual." />,
				});
			}
		} catch (error) {
			console.error("Erro inesperado:", error);
			toastHandler.present({
				type: "error",
				position: "top-right",
				messageOrContent: <ToastContent title="Erro" content="Falha ao processar as baixas manuais." />,
			});
		} finally {
			setIsLoading(false);
		}
	};

	

	return {
		handleCancelComissions,
		handlePaymentComissions,
	};
};
